import { createVuetify } from "vuetify";

export const vuetify = createVuetify();
